import type { Splash as SplashProps } from 'autogen/swagger/all';
import { FixedLowPriceSplashAltText } from 'autogen/translation-keys/trans-website-splash';
import { withErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { breakpoint } from 'variables';

const Splash = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    max-width: 60px;
    height: auto;

    ${breakpoint.up('1025px')} {
        max-width: 90px;
    }
`;

function FixedLowPriceSplash(splash: SplashProps) {
    const { imageUrl } = splash;
    const { t } = useTranslation();

    return <Splash src={imageUrl} alt={t(FixedLowPriceSplashAltText)} />;
}

export default withErrorBoundary(FixedLowPriceSplash, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
